var map = {
	"./en/change-password.json": 4229,
	"./en/general.json": 1797,
	"./en/patients.json": 6624,
	"./fr/change-password.json": 8274,
	"./fr/general.json": 1378,
	"./fr/patients.json": 8933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2495;